import { render, staticRenderFns } from "./Tukang_Staff_Form.vue?vue&type=template&id=9a7c28a0&scoped=true&"
import script from "./Tukang_Staff_Form.vue?vue&type=script&lang=js&"
export * from "./Tukang_Staff_Form.vue?vue&type=script&lang=js&"
import style0 from "./Tukang_Staff_Form.vue?vue&type=style&index=0&id=9a7c28a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7c28a0",
  null
  
)

export default component.exports